import React, { useState } from 'react';
import SpinnerLoad from '../../moduleComponents/SpinnerLoad';
import DatePicker from 'shared_items/DatePicker';
import { formatDateLocal } from 'shared_items/formatConventions';

const ALL_CALENDARS_ID = '';

export default function CardTodoListAdd({ onSubmit, submitting, isCreating, onCancel, calendars = [], defaultCalendarId = null }) {
  const [form, setForm] = useState({
    title: '',
    date: formatDateLocal(new Date()),
    calendar_id: defaultCalendarId != null ? defaultCalendarId : (calendars[0]?.id ?? null),
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: name === 'calendar_id' ? (value === ALL_CALENDARS_ID ? null : Number(value)) : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (form.title && form.date) {
      const payload = { title: form.title, date: form.date };
      if (form.calendar_id != null) payload.calendar_id = form.calendar_id;
      onSubmit(payload);
      setForm({ title: '', date: formatDateLocal(new Date()), calendar_id: form.calendar_id });
    }
  };

  const handleCancel = () => {
    setForm({ title: '', date: formatDateLocal(new Date()), calendar_id: defaultCalendarId ?? (calendars[0]?.id ?? null) });
    onCancel();
  };

  if (isCreating) {
    return (
      <div className="bg-white rounded-2xl shadow p-0 overflow-hidden relative h-28">
        <div className="px-4 py-3 space-y-2">
          <div className="h-8 bg-gray-400 rounded animate-pulse"></div>
          <div className="flex gap-2">
            <div className="w-48 h-8 bg-gray-400 rounded animate-pulse"></div>
            <div className="flex-1 h-8 bg-gray-400 rounded animate-pulse"></div>
            <div className="flex-1 h-8 bg-gray-400 rounded animate-pulse"></div>
          </div>
        </div>
        <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-60">
          <SpinnerLoad />
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-2xl shadow p-0 overflow-hidden flex flex-col">
      <form onSubmit={handleSubmit} className="px-4 py-3 space-y-2">
        <input
          name="title"
          value={form.title}
          onChange={handleChange}
          placeholder="Task title"
          className="w-full border rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          disabled={submitting}
          required
          autoFocus
        />
        <div className="flex flex-wrap gap-2 items-end">
          <DatePicker
            name="date"
            value={form.date}
            onChange={handleChange}
            colorScheme="blue"
            disabled={submitting}
            required
            className="w-40"
          />
          {calendars.length > 0 && (
            <div className="flex flex-col gap-0.5">
              <label className="text-xs text-gray-500">Calendar</label>
              <select
                name="calendar_id"
                value={form.calendar_id ?? ALL_CALENDARS_ID}
                onChange={handleChange}
                className="border rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 min-w-[140px]"
                disabled={submitting}
              >
                <option value={ALL_CALENDARS_ID}>None</option>
                {calendars.map((cal) => (
                  <option key={cal.id} value={cal.id}>{cal.name}</option>
                ))}
              </select>
            </div>
          )}
          <button
            type="submit"
            className="flex-1 bg-blue-700 hover:bg-blue-700 text-white font-semibold px-4 py-2 rounded disabled:opacity-60 transition"
            disabled={submitting || !form.title || !form.date}
          >
            {submitting ? 'Adding...' : 'Add'}
          </button>
          <button
            type="button"
            onClick={handleCancel}
            className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded hover:bg-gray-50 transition"
            disabled={submitting}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}
